import type { Platform } from '@moonpig/web-core-types'

export const getPlatform = (isMobile: boolean): Platform => {
  return {
    isMobile,
    source: isMobile ? 'MOBILE WEB' : 'WEB',
  }
}
